import { VppTransactionPayload, AddressInput, CustomerType } from '@buy-viasat/types/build/bv';
import gql from 'graphql-tag';
import { client } from 'shared/containers/apollo';
import { ApolloQueryResult } from '@apollo/client';

const CREATE_VPP_TRANSACTION = gql`
  query createVPPTransaction($input: UpdateVPPTransactionInput!) {
    createVPPTransaction(input: $input) {
      transactionId
    }
  }
`;

export type CreateVPPTransactionResponse = ApolloQueryResult<VppTransactionPayload>;

export default async function createVPPTransactionAsync(options: {
  relnId: string;
  email: string;
  billingAddress: AddressInput;
  spbBillingAccountId: string;
  oneTimeTotal: number;
  userAgent: string;
  customerType: CustomerType;
  phone: string;
}): Promise<CreateVPPTransactionResponse> {
  return client.query({
    query: CREATE_VPP_TRANSACTION,
    fetchPolicy: 'no-cache',
    variables: {
      input: {
        email: options.email,
        billingAddress: options.billingAddress,
        customerRef: options.relnId,
        spbBillingAccountId: options.spbBillingAccountId,
        txnAmount: options.oneTimeTotal,
        userAgent: options.userAgent,
        customerType: options.customerType,
        phone: options.phone,
      },
    },
  });
}
